import Swal from 'sweetalert2'
import axios from 'axios'

import Emitter from '../event/emitter'
import * as instanceMethods from './_main'
import * as staticMethods from '../helper/is'

class Alert extends Emitter {
  constructor(...args) {
    super()

    const outerParams = Object.freeze(this.constructor.argsToParams(args))

    Object.defineProperties(this, {
      params: {
        value: outerParams,
        writable: false,
        enumerable: true,
        configurable: true,
      },
    })

    this.main(this.params)
  }

  /**
   * @param {String} uri
   * @return {Promise}
   */
  static axiosDelete(uri) {
    return axios.delete(uri, { headers: { 'Content-Type': 'application/json' }})
  }

  /**
   * @param {FormData} formData
   * @param {String} uri
   * @return {Promise}
   */
  static axiosPost(formData, uri) {
    return axios.post(uri, formData, { headers: { 'Content-Type': 'multipart/form-data' }})
  }

  /**
   * @param {Object} formData
   * @param {String} uri
   * @return {Promise}
   */
  static axiosGet(formData, uri) {
    return axios.get(`${uri}${this.createTheParametersOfTheUrl(formData)}`, { headers: { 'Content-Type': 'application/json' }})
  }

  /**
   * @param {Object} params
   * @return {Swal}
   */
  static mixin(params) {
    return Swal.mixin(params)
  }

  /**
   * @param {Object} params
   * @return {Promise}
   */
  fire() {
    return Swal.fire(this.params)
  }

  /**
   * @param {Object} params
   * @return {Swal}
   */
  finalize(callback) {
    return this.fire().then(response => callback(response))
  }

  /**
   * @param {Boolean} succeeded
   * @param {*} params
   * @param {String?} eventMessage
   * @return {*}
   */
  static handleResult(succeeded, params, eventMessage) {
    if (!this.checkVariable(eventMessage) && succeeded === true) {
      eventMessage = 'success'
    } else if (!this.checkVariable(eventMessage) && succeeded === false) {
      eventMessage = 'error'
    }

    return this.prototype.emit(eventMessage, {
      params,
      clearSelection: this.clearSelection.bind(this),
    })
  }

  /**
   * @param {String} name
   * @param {Function} callback
   * @param {*} ctx
   * @return {*}
   */
  static handleOn(name, callback, ctx) {
    return this.prototype.on(name, callback, ctx)
  }

  /**
   * @param {String} name
   * @param {Function} callback
   * @param {*} ctx
   * @return {*}
   */
  static clearSelection(name, callback, ctx) {
    return this.prototype.off(name, callback, ctx)
  }
}

// Assign instance methods from _main/*.js to prototype
Object.assign(Alert.prototype, instanceMethods)

// Assign static methods from is/*.js to constructor
Object.assign(Alert, staticMethods)

exports.Alert = Alert
export default Alert
